module.exports = __webpack_public_path__ + "static/portfolio_gallery_29-4869d8911031b7dd27bafaf9c6ddcd78.jpg";